import createPlugin from '@@/create-plugin';

export default createPlugin({
    components: {
        page: () => import('./components/root')
    }
});
